import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import mitt from "mitt"; // 컴포넌트간 통신
import VueEasyLightbox from 'vue-easy-lightbox'

//https://primevue.org/
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css'

// sweetalert2
// https://sweetalert2.github.io/
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
// 알랏 공통 옵션
const options = {
    confirmButtonColor: '#80DB39',
    cancelButtonColor: '#FFF',
    confirmButtonText: '확인',
    cancelButtonText: '취소'
  };


import '../src/assets/css/style.css'
import '../src/assets/css/account.css'
import '../src/assets/css/font.css'
import '../src/assets/css/blog.css';


const app = createApp(App);

const emitter = mitt();
app.config.globalProperties.emitter = emitter

app.use(router).use(store).use(VueEasyLightbox).mount('#app')
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: false || 'none',
        }
    }
});
app.use(VueSweetalert2, options);




